import { render, staticRenderFns } from "./driver-card-data-groups-analysis.vue?vue&type=template&id=27aad23d&scoped=true"
import script from "./driver-card-data-groups-analysis.vue?vue&type=script&lang=js"
export * from "./driver-card-data-groups-analysis.vue?vue&type=script&lang=js"
import style0 from "./driver-card-data-groups-analysis.vue?vue&type=style&index=0&id=27aad23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aad23d",
  null
  
)

export default component.exports